<template>
  <div class="questionnaire" :class="{'questionnaire--simple-question': simpleQuestion}">
    <Loader v-if="isLoadingData" is-loading without-opacity/>
    <template v-else-if="Object.keys(computedPolls).length" >
      <div
        class="questionnaire__wrap"
        :class="{'questionnaire__wrap--border': questionnaire}"
        v-for="(value, uid) in computedPolls"
        :key="uid"
      >
        <ThankYou v-if="!questionnaire && sendInfo[uid] && sendInfo[uid].success" :user-name="sendInfo[uid]['user_name']" />
        <div v-else>
          <!-- Temporary disable title dispay -->
          <!--           <p v-if="questionnaire" class="questionnaire__title">{{ polls[uid].title }}</p>-->
          <div
            class="questionnaire__poll-wrap"
            v-for="(poll, key) in value"
            :key="key"
            v-show="isShowQuestion(uid, poll)"
          >
            <p
              class="questionnaire__poll-title"
              :class="{'questionnaire__poll-title--error': isErrorInQuestion(uid, poll)}"
            >
              {{ poll.title }}{{poll.required === '1' ? '*' : ''}}
            </p>
            <template v-if="poll.type === questionTypes.TEXTAREA_TYPE">
              <Textarea
                :poll="poll"
                :questionnaire-uid="uid"
                :results="results"
                :email-mask="questionTypes.EMAIL_MASK"
                :phone-mask="questionTypes.PHONE_MASK"
                :text-mask="questionTypes.TEXT_MASK"
                :city-mask="questionTypes.CITY_MASK"
                :simple-question="simpleQuestion"
              />
            </template>
            <template v-else-if="poll.type === questionTypes.RADIO_RATE_TYPE">
              <RadioButtons
                :questionnaire-uid="uid"
                :questionUid="poll.uid"
                :poll-type="poll.type"
                :rateCount="Number(poll.rate_count)"
                :simple-question="simpleQuestion"
              />
            </template>
            <template v-else-if="poll.type === questionTypes.RADIO_TYPE">
              <template v-for="item in poll.pollQuestionPreparedAnswers">
                <Radio
                  :name="`qualityCheckbox${poll.id}`"
                  :label="item.title"
                  :key="item.id"
                  :value="results[uid].answers[key].answer.includes(item.uid) ? item.title : ''"
                  type="questionnaire"
                  :simple-question="simpleQuestion"
                  @change="handleInputs(uid, key, [item.uid], poll.type)"
                />
              </template>
            </template>
            <template v-else-if="poll.type === questionTypes.CHECKBOX_TYPE">
              <template v-for="item in poll.pollQuestionPreparedAnswers">
                <Checkbox
                  v-if="!poll.mask || results[uid].answers[poll.parent_question_uid].answer.includes(poll.parent_answer_uid)"
                  :name="poll.id + item.id"
                  :label="poll.mask === questionTypes.LINK_MASK ? linkData(linkType(item.title)).label : item.title"
                  :key="item.id"
                  :value="results[uid].answers[key].answer.includes(item.uid)"
                  :simple-question="simpleQuestion"
                  @input="handleInputs(uid, key, item.uid, poll.type)"
                />
                <div v-else-if="poll.mask === questionTypes.LINK_MASK"
                     class="questionnaire__link-wrap"
                     :class="['questionnaire__link-wrap--' + linkType(item.title)]"
                     :key="item.id">
                  <a class="questionnaire__link" :href="item.title" target="_blank">
                    <svg v-if="linkData(linkType(item.title)).icon" width="15" height="15">
                      <use :xlink:href="linkData(linkType(item.title)).icon"></use>
                    </svg>
                    <span v-else>{{ item.title }}</span>
                  </a>
                </div>
              </template>
            </template>
            <template v-else-if="poll.type === questionTypes.DATE_TYPE">
              <CustomDatePicker
                class="questionnaire__poll-date"
                :value="results[uid].answers[key].answer[0]"
                :placeholder="$t('choose_date')"
                format="DD.MM.YYYY"
                value-type="DD.MM.YYYY H:mm:ss"
                title-format="DD.MM.YYYY"
                @input="handleInputs(uid, key, $event, poll.type)"
                :append-to-body="false"
              />
            </template>
            <template v-else-if="poll.type === questionTypes.NUMBER_TYPE">
              <Number
                :poll="poll"
                :questionnaire-uid="uid"
                :results="results"
                :questionnaire="value.questionnaire === '1'"
              />
            </template>
            <p v-if="isErrorInQuestion(uid, poll)" class="error-message">{{ 'Обов\'язково для заповнення' }}</p>

          </div>
          <div class="questionnaire__btns">
            <Button
              v-if="showTrimmedPoll[uid]"
              class="questionnaire__btn questionnaire__btn--change-status"
              type="plain"
              @click.native="changeShowAllQuestionsStatus(uid)"
            >
              {{ $t('questionnaire_show_all_questions') }}
            </Button>
            <Button class="questionnaire__btn" @click.native="submitForm(uid)">{{ $t('quality_btn') }}</Button>
          </div>
        </div>
      </div>
    </template>
    <div v-else class="warning-block">
      <h1 class="warning-block__title">{{ $t('sorry') }}</h1>
      <span>{{ $t('evaluation_completed') }}</span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Textarea from '../../components/quality/Textarea'
import Radio from '../../components/inputs/Radio'
import RadioButtons from '../../components/quality/RadioButtons'
import Checkbox from '../../components/inputs/Checkbox'
import Button from '../../components/inputs/Button'
import CustomDatePicker from '../../components/inputs/CustomDatePicker'
import { spritePath } from '@/mixins/spritePath'
import Number from '../../components/quality/Number'
import ThankYou from './ThankYou'
import Loader from '../helpers/Loader'

export default {
  name: 'FormQuestions',
  mixins: [spritePath],
  props: {
    getQuestionsEndpoint: {
      type: String,
      required: true
    },
    postQuestionsEndpoint: {
      type: String,
      required: true
    },
    pollId: {
      type: String,
      default: ''
    },
    questionnaire: {
      type: Boolean,
      default: false
    },
    simpleQuestion: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Number,
    Button,
    Textarea,
    Radio,
    RadioButtons,
    Checkbox,
    CustomDatePicker,
    ThankYou,
    Loader
  },
  computed: {
    ...mapGetters('questionnaire', ['questionnaireErrors', 'pollQuestionsForDisplaying', 'computedPolls']),
    ...mapState({
      polls: state => state.cabinet.questionnaire.polls,
      results: state => state.cabinet.questionnaire.results,
      sendInfo: state => state.cabinet.questionnaire.sendInfo,
      submittedStatus: state => state.cabinet.questionnaire.submittedStatus,
      showTrimmedPoll: state => state.cabinet.questionnaire.showTrimmedPoll,
      isLoadingData: state => state.cabinet.questionnaire.loadingData,
      questionTypes: state => state.cabinet.questionnaire.questionTypes
    })
  },
  methods: {
    ...mapActions('questionnaire', ['GET_QUESTIONS', 'SET_ANSWER_ACTION', 'SEND_RESULTS', 'SET_REQUEST_ID_ACTION',
      'CHANGE_SHOW_TRIMMED_POLL_ACTION']),
    linkType (link) {
      if (link.includes('t.me')) return this.questionTypes.TELEGRAM_LINK_TYPE
      else if (link.includes('2JmrOPv')) return this.questionTypes.VIBER_LINK_TYPE
      else if (link.includes('instagram')) return this.questionTypes.INSTAGRAM_LINK_TYPE
      else if (link.includes('facebook')) return this.questionTypes.FACEBOOK_LINK_TYPE
      else if (link.includes('tiktok')) return this.questionTypes.TIKTOK_LINK_TYPE
      else if (link.includes('youtube')) return this.questionTypes.YOUTUBE_LINK_TYPE

      return this.questionTypes.DEFAULT_LINK_TYPE
    },
    linkData (type) {
      const link = {
        icon: '',
        label: ''
      }

      switch (type) {
        case this.questionTypes.TELEGRAM_LINK_TYPE:
          link.icon = this.spritePath + '#telegram'
          link.label = 'Telegram'
          break
        case this.questionTypes.VIBER_LINK_TYPE:
          link.icon = this.spritePath + '#viber'
          link.label = 'Viber'
          break
        case this.questionTypes.INSTAGRAM_LINK_TYPE:
          link.icon = this.spritePath + '#instagram'
          link.label = 'Instagram'
          break
        case this.questionTypes.FACEBOOK_LINK_TYPE:
          link.icon = this.spritePath + '#facebook'
          link.label = 'Facebook'
          break
        case this.questionTypes.TIKTOK_LINK_TYPE:
          link.icon = this.spritePath + '#tiktok'
          link.label = 'TikTok'
          break
        case this.questionTypes.YOUTUBE_LINK_TYPE:
          link.icon = this.spritePath + '#youtube'
          link.label = 'YouTube'
          break
      }

      return link
    },
    resetAnswersByParents (questionnaireUid, pollUid) {
      const questions = this.polls[questionnaireUid].pollQuestions

      for (let item in questions) {
        if (
          questions[item].parent_question_uid === pollUid &&
          this.results[questionnaireUid].answers[questions[item].uid].answer.length
        ) {
          this.handleInputs(questionnaireUid, questions[item].uid, [], 'reset', questions[item])
        }
      }
    },
    handleInputs (uid, answerUid, answer, type) {
      this.resetAnswersByParents(uid, answerUid)

      this.SET_ANSWER_ACTION({
        uid: uid,
        answerUid: answerUid,
        answer: answer,
        type: type
      })
    },
    handleNotify (group, text) {
      this.$notify({
        group: group,
        title: group === 'error' ? this.$t('error') : '',
        text: text,
        type: group
      })
    },
    submitForm (uid) {
      this.SEND_RESULTS({ pollUid: uid, endpoint: this.postQuestionsEndpoint, getEndpoint: this.getQuestionsEndpoint, part: this.simpleQuestion })
        .then(res => {
          if (res.data && res.data.success) {
            this.handleNotify('success', this.$t('questionnaire_success'))
            this.$emit('submit')
          } else {
            this.handleNotify('error', this.$t('error_occurred'))
          }
        })
        .catch(err => {
          this.handleNotify('error', err.message)
        })
    },
    changeShowAllQuestionsStatus (uid) {
      this.CHANGE_SHOW_TRIMMED_POLL_ACTION({
        uid,
        status: !this.showTrimmedPoll[uid]
      })
    },
    isShowQuestion (uid, poll) {
      return this.showTrimmedPoll[uid] ? true : (poll.mask !== this.EMAIL_MASK) || (poll.mask === this.EMAIL_MASK &&
        poll.required === '1')
    },
    isErrorInQuestion (uid, poll) {
      return this.submittedStatus[uid] && this.questionnaireErrors[uid].includes(poll.uid)
    }
  },
  mounted () {
    this.SET_REQUEST_ID_ACTION(this.pollId)
    this.GET_QUESTIONS({ endpoint: this.getQuestionsEndpoint, pollId: this.pollId })
  }
}
</script>

<style scoped lang="sass">

.questionnaire__wrap
  margin: 0 0 40px

  +mmin($tablet--hor)
    margin: 0 0 30px

  &--border
    padding: 20px
    border: 1px solid $nd-border-color
    border-radius: 3px

.questionnaire__title
  font-size: 18px
  font-weight: 500
  margin: 0 0 30px

.questionnaire__poll-wrap
  margin: 0 0 30px

.questionnaire__poll-title
  font-size: 16px
  margin: 0 0 15px

  &--error
    color: $nd-error-text-color

.error-message
  color: $nd-error-text-color
  margin: 10px 0 0 5px

.questionnaire__btns
  width: 100%
  display: flex
  flex-flow: column
  align-items: center

  +mmin($extsmall--hor)
    flex-flow: row nowrap

.questionnaire__btn
  margin: 0 auto
  flex-shrink: 0

  &--change-status
    margin: 0 auto 0 0

    +mmin($extsmall--hor)
      margin: 0 0 0 auto

  & + .questionnaire__btn
    margin: 20px auto 0 0

    +mmin($extsmall--hor)
      margin: 0 auto 0 20px

.questionnaire__link-wrap
  display: inline-block
  position: relative
  width: 30px
  height: 30px
  background-color: #f5f5f5
  border-radius: 50%
  transition: .4s
  cursor: pointer

  &:not(:last-child)
    margin-right: 10px

  svg
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    fill: #fff
    transition: .2s

  &--telegram
    background-color: #0088CC

    &:hover
      background-color: darken(#0088CC, 10%)

  &--facebook
    background-color: #4267B2

    &:hover
      background-color: darken(#4267B2, 10%)

  &--youtube
    background-color: #FF0000

    &:hover
      background-color: darken(#FF0000, 10%)

  &--instagram
    background-color: #BF2F97

    &:hover
      background-color: darken(#BF2F97, 10%)

  &--viber
    background-color: #665CAC

    &:hover
      background-color: darken(#665CAC, 10%)

  &--tiktok
    background-color: #444444

    &:hover
      background-color: darken(#444444, 10%)

.questionnaire__link
  display: block
  width: 100%
  height: 100%

.warning-block
  text-align: center
  margin: 150px 0 300px

.warning-block__title
  margin-bottom: 40px

.questionnaire__poll-date
  max-width: 300px

// simple question
.questionnaire--simple-question
  .questionnaire__wrap
    border: none
    margin: 0
    padding: 0

  .questionnaire__poll-wrap
    margin: 0 0 20px

  .questionnaire__poll-title
    font-size: 18px
    font-weight: 500
    padding: 0 35px 0 0
    margin: 0 0 20px

  .questionnaire__btn
    margin: 0 auto 0 0

</style>
